export const api="https://caliber.uz"